import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPlus, faSearch} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
    type: 'no-events' | 'no-results';
    onClearFilters?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ type, onClearFilters }) => {
    const { t } = useTranslation();
    if (type === 'no-events') {
        return (
            <div className="text-center py-16">
                <div className="glass-card p-12">
                    <FontAwesomeIcon icon={faPlus} className="text-6xl mb-6 text-gray-600 dark:text-gray-300"/>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                        {t('myEvents.emptyState.noEvents.title')}
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300 mb-8 max-w-md mx-auto">
                        {t('myEvents.emptyState.noEvents.description')}
                    </p>
                    <Link
                        to="/create-event"
                        className="glass-btn-primary inline-flex items-center"
                    >
                        <FontAwesomeIcon icon={faPlus} className="mr-2" />
                        {t('myEvents.emptyState.noEvents.button')}
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="text-center py-16">
            <div className="glass-card p-12">
                <FontAwesomeIcon icon={faSearch} className="text-6xl mb-6 text-gray-600 dark:text-gray-300"/>
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                    {t('myEvents.emptyState.noResults.title')}
                </h2>
                <p className="text-gray-600 dark:text-gray-300 mb-6">
                    {t('myEvents.emptyState.noResults.description')}
                </p>
                <button
                    onClick={onClearFilters}
                    className="glass-btn-primary !px-4 !py-2"
                >
                    {t('myEvents.emptyState.noResults.button')}
                </button>
            </div>
        </div>
    );
};

export default EmptyState;